import { withInstall } from '../../../utils/with-install'
import ThreeGltf from './ThreeGltf.vue'

export const ElAmapThreeGltf = withInstall(ThreeGltf)
export default ElAmapThreeGltf
